import { render } from "./MegaFiles.vue?vue&type=template&id=413f0c32"
import script from "./MegaFiles.vue?vue&type=script&lang=js"
export * from "./MegaFiles.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/megaluzz-admin/megaluzz-admin/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__